import {useDebugValue} from 'react';

import {
    getNoUndefArray,
    getUniqueArray
} from '../../../utils';

function useStoreKeys(config, defaultStore, otherStores) {
    const {
        storeKeysRef
    } = config;

    const {
        [storeKeysRef]: defaultKeys
    } = defaultStore;

    const otherKeys = getNoUndefArray(otherStores.map((store) => (
        store[storeKeysRef]
    )));

    const specifiedKeys = otherKeys.reduce((accumulatedKeys, currentKeys) => ([
        ...accumulatedKeys,
        ...getNoUndefArray(currentKeys)
    ]), []);

    const storeKeys = getUniqueArray([
        ...defaultKeys,
        ...specifiedKeys
    ]);

    const result = {
        storeKeys
    };

    useDebugValue(result);

    return result;
}

export {useStoreKeys};
